import React, { useState } from 'react';
import {
AreaChart,
Area,
XAxis,
YAxis,
Tooltip,
ResponsiveContainer,
CartesianGrid,
} from 'recharts';
import { Button, ButtonGroup, Typography, Paper, CircularProgress, Box } from '@mui/material';

import dayjs from 'dayjs';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import 'dayjs/locale/es';
import { useRevenueMetrics } from '../../../../hook/useRevenueMetrics';

dayjs.extend(weekOfYear);
dayjs.locale('es');



const getDateRange = (range) => {
const end = dayjs();
let start;

switch (range) {
case 'week':
start = end.subtract(6, 'day');
break;
case 'month':
start = end.subtract(28, 'day');
break;
case 'year':
start = end.subtract(1, 'year');
break;
default:
start = end.subtract(6, 'day');
}

return {
startDate: start.format('YYYY-MM-DD'),
endDate: end.format('YYYY-MM-DD')
};
};

const mapRangeToPeriod = {
week: 'day',
month: 'week',
year: 'month',
};

const formatXAxis = (value, range) => {
const date = dayjs(value);

switch (range) {
case 'week':
return date.format('dd'); // Lu, Ma, Mi, ...
case 'month':
  return `Sem ${date.week()}`;
case 'year':
return date.format('MMM'); // Ene, Feb, Mar
default:
return value;
}
};

export function SalesBarChart() {
const [range, setRange] = useState('week');
const { startDate, endDate } = getDateRange(range);
const period = mapRangeToPeriod[range];
const location = 1;

const { data, loading, error } = useRevenueMetrics({
period,
startDate,
endDate,
location
});

return (
<>
<div className="row justify-content-between">
  <div className='mp-6'>
<h3>Ingresos por {range === 'week' ? 'día' : range === 'month' ? 'semana' : 'mes'}</h3> 
</div>
<div className='mp-6'>
<ButtonGroup variant="outlined" size="small" sx={{ mb: 2 }}>
    {['week', 'month', 'year'].map((r) => (
      <Button
        key={r}
        onClick={() => setRange(r)}
        variant={range === r ? 'contained' : 'outlined'}
      >
        {r.charAt(0).toUpperCase() + r.slice(1)}
      </Button>
    ))}
  </ButtonGroup>
  </div>
  </div>
  {loading ? (
    <Box display="flex" justifyContent="center" alignItems="center" height={250}>
      <CircularProgress />
    </Box>
  ) : error ? (
    <Typography color="error">Error al cargar los datos.</Typography>
  ) : (
    <ResponsiveContainer width="100%" height={250}>
      <AreaChart data={data}>
        <defs>
          <linearGradient id="colorSales" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#f87171" stopOpacity={0.3} />
            <stop offset="95%" stopColor="#f87171" stopOpacity={0} />
          </linearGradient>
        </defs>
        <XAxis
          dataKey="period"
          tick={{ fontSize: 12 }}
          tickFormatter={(value) => formatXAxis(value, range)}
        />
        <YAxis tick={{ fontSize: 12 }} />
        <CartesianGrid strokeDasharray="3 3" vertical={false} />
        <Tooltip
          contentStyle={{ backgroundColor: '#facc15', borderRadius: '8px' }}
          labelStyle={{ fontWeight: 'bold' }}
          formatter={(value) => [`S/ ${value}`, 'Total']}
          labelFormatter={(label) => `Fecha: ${label}`}
        />
        <Area
          type="monotone"
          dataKey="total"
          stroke="#ef4444"
          fillOpacity={1}
          fill="url(#colorSales)"
          strokeWidth={3}
          dot={{ r: 4, fill: '#ef4444', strokeWidth: 2, stroke: '#fff' }}
          activeDot={{ r: 6, stroke: '#facc15', strokeWidth: 4 }}
        />
      </AreaChart>
    </ResponsiveContainer>
  )}
</>

);
};

